import { render } from "./agentInfo.vue?vue&type=template&id=195d0a7b"
import script from "./agentInfo.vue?vue&type=script&lang=js"
export * from "./agentInfo.vue?vue&type=script&lang=js"

import "./agentInfo.vue?vue&type=style&index=0&id=195d0a7b&lang=scss"

import exportComponent from "/builds/feng.chen/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__